module.exports = __webpack_public_path__ + "static/media/trophy.d9092b21.svg";